import { React, useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { BiSliderAlt } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { searchEmails } from "../../services/api";

import AdvancedEmailSearchForm from "../../components/form/AdvancedEmailSearchForm";
import { DataState } from "../../context/DataProvider";
import toast from "react-hot-toast";

import { useEmails } from "../../context/EmailsProvider";

export default function EmailSearch({ setIsSearchBoxOpen, isAdvanceSearchOpen, setIsAdvancedSearchOpen, isOutlook }) {
    const { userInfo, userGoogleId } = DataState();
    const [searchQuery, setSearchQuery] = useState("");
    const [query, setQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const { emails, setEmails, setIsSearchDone, setTotalEmails, totalEmails, } = useEmails();
    const [initialEmails, setInitialEmails] = useState([]);
    const [formData, setFormData] = useState({
        searchIn: "all folders",
        from: "",
        to: "",
        cc: "",
        subject: "",
        keyword: "",
        dateFrom: "",
        dateTo: "",
        readStatus: "all",
        attachments: false,
    });

    const handleReset = () => {
        setFormData({
            searchIn: "all folders",
            from: "",
            to: "",
            cc: "",
            subject: "",
            keyword: "",
            dateFrom: "",
            dateTo: "",
            readStatus: "all",
            attachments: false,
        });
    };

    const handleSearchEmailss = async () => {
        if (
            !searchQuery.trim() &&
            !formData.subject.trim() &&
            !formData.keyword.trim() &&
            !formData.from.trim() &&
            !formData.to.trim() &&
            !formData.cc.trim() &&
            !formData.dateFrom.trim() &&
            !formData.dateTo.trim() &&
            !formData.attachments &&
            formData.readStatus === "all"
        ) {
            toast.error("Please enter something to search!");
            return;
        }

        setLoading(true);
        try {
            setInitialEmails(emails);

            let filterConditions = [];

            // Handle Normal Text Search (Phrase Search)
            if (searchQuery) {
                const phrase = `"${searchQuery}"`;
                setQuery(phrase);

            }

            // Handle Keyword Search
            if (formData.keyword) {
                const sq = searchQuery
                    ? `"${searchQuery}" OR "${formData.keyword}"`
                    : formData.keyword; // Merge with phrase search if applicable

                setQuery(sq)
            }

            // Handle Subject Search
            if (formData.subject) {
                filterConditions.push(`contains(subject, '${formData.subject}')`);
            }

            // Handle "From" Filter
            if (formData.from) {
                filterConditions.push(`from/emailAddress/address eq '${formData.from}'`);
            }

            // ######################################

            // getting error with to and cc fields

            // #######################################
            // Handle "To" Filter
            if (formData.to) {
                // filterConditions.push(`toRecipients/any(r: r/emailAddress/address eq '${formData.to}')`);
                filterConditions.push("toRecipients/any()");
            }
            // toRecipients/any(r: r/emailAddress/address eq 'recipient@example.com')

            // // Handle "CC" Filter
            if (formData.cc) {
                filterConditions.push(`ccRecipients/any(r: r/emailAddress/address eq '${formData.cc}')`);
            }

            // Handle Read/Unread Status
            if (formData.readStatus !== "all") {
                filterConditions.push(`isRead eq ${formData.readStatus === "read"}`);
            }

            // Handle Attachments
            if (formData.attachments) {
                filterConditions.push(`hasAttachments eq true`);
            }

            // Handle Date Range
            if (formData.dateFrom && formData.dateTo) {
                filterConditions.push(
                    `receivedDateTime ge ${formData.dateFrom}T00:00:00Z AND receivedDateTime le ${formData.dateTo}T23:59:59Z`
                );
            }

            // Encode search query and filter conditions
            const encodedSearch = searchQuery ? encodeURIComponent(searchQuery) : "";
            const encodedFilter = filterConditions.length ? filterConditions.join(" AND ") : "";


            // Call the API with the formatted query
            console.log("filterConditions: ", filterConditions);
            const response = await searchEmails(userGoogleId, query, encodedFilter, 1, 20, isOutlook);
            setEmails(response?.emails);
            setSearchResults(response || []);
            toast.success("Emails retrieved successfully!");
            setIsAdvancedSearchOpen(false);
        } catch (error) {
            console.error("Search Emails Error:", error);
            toast.error("Failed to fetch emails. Try again.");
        } finally {
            setLoading(false);
        }
    };
    const handleSearchEmails = async () => {
        if (
            !searchQuery.trim() &&
            !formData.subject.trim() &&
            !formData.keyword.trim() &&
            !formData.from.trim() &&
            !formData.to.trim() &&
            !formData.cc.trim() &&
            !formData.dateFrom.trim() &&
            !formData.dateTo.trim() &&
            !formData.attachments &&
            formData.readStatus === "all"
        ) {
            toast.error("Please enter something to search!");
            return;
        }
    
        setLoading(true);
        try {
            setInitialEmails(emails);
    
            let filterConditions = [];
            let finalSearchQuery = searchQuery || ""; // Initialize with existing search query
    
            if (isOutlook) {
                // Outlook Search - Uses filterConditions
    
                // Handle Subject Search
                if (formData.subject) {
                    filterConditions.push(`contains(subject, '${formData.subject}')`);
                }
    
                // Handle "From" Filter
                if (formData.from) {
                    filterConditions.push(`from/emailAddress/address eq '${formData.from}'`);
                }
    
                // Handle "To" Filter
                if (formData.to) {
                    filterConditions.push("toRecipients/any()");
                }
    
                // Handle "CC" Filter
                if (formData.cc) {
                    filterConditions.push(`ccRecipients/any(r: r/emailAddress/address eq '${formData.cc}')`);
                }
    
                // Handle Read/Unread Status
                if (formData.readStatus !== "all") {
                    filterConditions.push(`isRead eq ${formData.readStatus === "read"}`);
                }
    
                // Handle Attachments
                if (formData.attachments) {
                    filterConditions.push(`hasAttachments eq true`);
                }
    
                // Handle Date Range
                if (formData.dateFrom && formData.dateTo) {
                    filterConditions.push(
                        `receivedDateTime ge ${formData.dateFrom}T00:00:00Z AND receivedDateTime le ${formData.dateTo}T23:59:59Z`
                    );
                }
    
            } else {
                // Gmail Search - Merge all formData fields into the search query
    
                let gmailSearchParts = [];
    
                if (formData.subject) {
                    gmailSearchParts.push(`subject:(${formData.subject})`);
                }
                if (formData.from) {
                    gmailSearchParts.push(`from:(${formData.from})`);
                }
                if (formData.to) {
                    gmailSearchParts.push(`to:(${formData.to})`);
                }
                if (formData.cc) {
                    gmailSearchParts.push(`cc:(${formData.cc})`);
                }
                if (formData.keyword) {
                    gmailSearchParts.push(`"${formData.keyword}"`);
                }
                if (formData.dateFrom && formData.dateTo) {
                    gmailSearchParts.push(`after:${formData.dateFrom} before:${formData.dateTo}`);
                }
                if (formData.readStatus === "read") {
                    gmailSearchParts.push("is:read");
                } else if (formData.readStatus === "unread") {
                    gmailSearchParts.push("is:unread");
                }
                if (formData.attachments) {
                    gmailSearchParts.push("has:attachment");
                }
    
                // Combine Gmail-specific search parts
                if (gmailSearchParts.length) {
                    finalSearchQuery += gmailSearchParts.join(" ");
                }
            }
    
            // Encode search query and filter conditions
            // const encodedSearch = finalSearchQuery ? encodeURIComponent(finalSearchQuery.trim()) : "";
            const encodedFilter = isOutlook && filterConditions.length ? filterConditions.join(" AND ") : "";
    
            // Call the API with the formatted query
            console.log("Final Search Query:", finalSearchQuery);
            console.log("Filter Conditions:", filterConditions);
    
            const response = await searchEmails(userGoogleId, finalSearchQuery, encodedFilter, 1, 20, isOutlook);
            setTotalEmails(response?.total_count || 0);
            setEmails(response?.emails);
            setSearchResults(response || []);
            toast.success("Emails retrieved successfully!");
            setIsAdvancedSearchOpen(false);
        } catch (error) {
            console.error("Search Emails Error:", error);
            toast.error("Failed to fetch emails. Try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        console.log("formdata is:", formData);

    }, [formData])

    const handleclose = () => {
        handleReset();
        if (searchQuery.trim()) {
            setSearchQuery("");
            return;
        }
        if (isAdvanceSearchOpen) {
            setIsAdvancedSearchOpen(false);
            
        }
        else {
            setIsSearchBoxOpen(false);
        }
        setIsSearchDone(prev => prev + 1)
    }


    return (
        <div className="w-full flex items-center">
            {/* Blurry Background Overlay */}
            {/* <div className="absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm "></div> */}

            {/* Search Box */}
            <div className="relative inline-block w-full pb-1  gap-2 transition-all duration-300">
                <div className="flex justify-between gap-2">
                    <div className="flex h-10 w-full items-center justify-between bg-zinc-900 border border-zinc-700 rounded-r-lg  px-3 py-2 text-zinc-300 shadow-md">
                        <div className="w-full flex items-center">
                            <FaSearch className="text-zinc-400 mr-2" size={18} />
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search emails..."
                                className="w-full bg-transparent focus:outline-none placeholder-zinc-500 text-sm"
                            />
                        </div>
                        
                        <div className="flex items-center gap-2">
                            <button
                                onClick={() => setIsAdvancedSearchOpen(!isAdvanceSearchOpen)}
                                className="flex items-center justify-center hover:bg-zinc-700 cursor-pointer rounded-full p-1"
                            >
                                <BiSliderAlt className="text-zinc-400 hover:text-zinc-300" size={20} />
                            </button>

                        </div>
                        



                    </div>
                    {!isAdvanceSearchOpen && (
                        <div className="flex  items-center bg-zinc-900 hover:bg-zinc-700 border border-zinc-700 rounded-lg px-2 text-zinc-300 shadow-md">
                            <button
                                onClick={handleSearchEmails}
                                disabled={loading}
                                className={` flex items-center justify-center text-zinc-400 hover:text-zinc-300  hover:bg-zinc-700 cursor-pointer rounded-lg p-1
                            ${loading ? "animate-pulse" : ""}
                            `}
                            >
                                {loading ?
                                    "Searching..."
                                    :
                                    "Search"
                                }
                            </button>
                        </div>
                    )}
                    <div
                        onClick={handleclose}
                        className="flex  items-center bg-zinc-900 hover:bg-zinc-700 border border-zinc-700 rounded-l-lg px-2 pl-1 text-zinc-300 shadow-md">
                        <button >
                            <IoClose className="text-zinc-400 hover:text-zinc-300" size={20} />
                        </button>
                    </div>

                </div>
                {isAdvanceSearchOpen && (
                    <div className="absolute right-0 pt-1  transform  shadow-lg  z-[60] ">
                        <AdvancedEmailSearchForm
                            formData={formData}
                            setFormData={setFormData}
                            handleSearchEmails={handleSearchEmails}
                            loading={loading}
                            handleReset={handleReset}
                        />

                    </div>
                )}
            </div>
        </div>
    );
}   